import { Button } from "@/components/ui/button";
import {
  CompanyContactCTA,
  CompanyPageHero,
  CompanyPageShell,
  CompanyServiceRow,
  useCompanyLang
} from "@/components/site/company/CompanyShared";
import {
  certificatesForCompanyGroup,
  companyBookingHref,
  companyCatalogGroups,
  companyInquiryHref,
  companyPaths,
  isCompanyDirectBooking
} from "@/data/company";
import { PageMeta } from "@/components/site/PageMeta";

const ForetagTjanster = () => {
  const { lang, copy } = useCompanyLang();
  const s = copy.tjanster;



  return (
    <CompanyPageShell breadcrumbLabel={copy.nav.tjanster}>
      <PageMeta title={s.metaTitle} description={s.metaDescription} titleMaxLength={70} />
      <CompanyPageHero label={s.label} title={s.title}>
        <p>{s.subtitle}</p>
        <nav className="flex flex-wrap gap-2 pt-2" aria-label={s.categoriesAria}>
          <a
            href="#drogtestning"
            className="rounded-full border border-border bg-card px-3 py-1.5 text-sm font-medium text-foreground/80 transition-base hover:border-primary/40 hover:text-primary"
          >
            {s.drugNav}
          </a>
          {companyCatalogGroups.map((group) => (
            <a
              key={group.id}
              href={`#kategori-${group.id}`}
              className="rounded-full border border-border bg-card px-3 py-1.5 text-sm font-medium text-foreground/80 transition-base hover:border-primary/40 hover:text-primary"
            >
              {group.title[lang]}
            </a>
          ))}
        </nav>
      </CompanyPageHero>

      <section id="drogtestning" className="scroll-mt-24 py-10 lg:py-12">
        <div className="container-wide">
          <div className="rounded-3xl border border-border/60 bg-card p-7 shadow-card sm:p-10">
            <h2 className="font-display text-3xl font-semibold tracking-tight text-foreground">{s.drugTitle}</h2>
            <p className="mt-4 max-w-3xl text-base leading-relaxed text-muted-foreground">{s.drugText}</p>
            <div className="mt-6 flex flex-col gap-3 sm:flex-row">
              <Button asChild variant="hero" size="lg">
                <a href={companyPaths.drogtestning[lang]}>{s.drugReadMore}</a>
              </Button>
              <Button asChild variant="ghost-outline" size="lg">
                <a href={companyInquiryHref(lang, "drogtest-forebyggande")}>{copy.shared.quoteCta}</a>
              </Button>
            </div>
          </div>
        </div>
      </section>

      {companyCatalogGroups.map((group) => {
        const items = certificatesForCompanyGroup(group.id);
        return (
          <section
            key={group.id}
            id={`kategori-${group.id}`}
            className="scroll-mt-24 pb-12 lg:pb-14"
          >
            <div className="container-wide">
              <h2 className="font-display text-3xl font-semibold tracking-tight text-foreground">
                {group.title[lang]}
              </h2>
              <div className="mt-6 space-y-4">
                {items.map((cert) => (
                  <CompanyServiceRow
                    key={cert.slug}
                    title={cert.title[lang]}
                    intro={cert.description[lang]}
                    price={cert.price[lang]}
                    actions={
                      <>
                        {isCompanyDirectBooking(cert.slug) ? (
                          <Button asChild variant="hero" size="sm">
                            <a href={companyBookingHref(lang, cert.slug)}>{copy.shared.bookEmployee}</a>
                          </Button>
                        ) : null}
                        <Button asChild variant="ghost-outline" size="sm">
                          <a href={companyInquiryHref(lang, cert.slug)}>{copy.shared.companyInquiry}</a>
                        </Button>
                      </>
                    }
                  />
                ))}
              </div>
            </div>
          </section>
        );
      })}

      <CompanyContactCTA title={s.ctaTitle} />
    </CompanyPageShell>
  );
};

export default ForetagTjanster;
